<div *ngIf="content" class="ticketType">
  <nx-ng-technical-difficulties
    [retryTextKey]="'refresh_results'"
    (close)="handleTechnicalDifficultiesClosed($event)"
    (showError)="handleShowError($event)"
  ></nx-ng-technical-difficulties>

  <ng-container *ngIf="!showError">
    <p class="ticketText">{{ 'search_for_suitable_tickets' | i18next }}</p>
    <nx-ng-ticket-category
      [title]="content.popular.titleKey"
      [description]="content.popular.descriptionKey"
      [mostPopular]="true"
      (clicked)="handleClick($event)"
    >
    </nx-ng-ticket-category>
    <p class="bundleText">{{ 'select_a_bundle' | i18next }}</p>
    <div class="ticketCategory" *ngFor="let option of content.others">
      <nx-ng-ticket-category
        [title]="option.titleKey"
        [description]="option.descriptionKey"
        [mostPopular]="false"
        (clicked)="handleClick($event)"
      >
      </nx-ng-ticket-category>
    </div>
  </ng-container>
</div>
